import axios from 'axios'
import HTTP from './http'

export default {
    getContent: () => axios.get(HTTP.EMBEDDED),
    updateLink: payload => axios.post(HTTP.EMBEDDED, { payload }),
    addEmbedded: payload => axios.patch(HTTP.EMBEDDED, { payload }),
    dlt: payload => axios.delete(HTTP.EMBEDDED, { params: payload })
}
